<template>
    <div class="relative flex grow flex-col overflow-y-auto">
        <img
            class="pointer-events-none absolute bottom-0 left-0 z-0 w-1/5"
            src="@/assets/images/background-lines-left-brown.svg"
            aria-hidden="true"
        />
        <img
            class="pointer-events-none absolute right-0 bottom-0 z-0 w-1/4"
            src="@/assets/images/background-lines-right-brown.svg"
            aria-hidden="true"
        />
        <div class="relative z-10 flex h-full grow flex-col">
            <slot />
        </div>
    </div>
</template>
